export default __webpack_public_path__ + "static/media/premiumicon.26a3040f.svg";